<template>
  <el-container style="height: 100vh; width:100% border: 1px solid #eee; ">
    <el-header style="text-align: right; font-size: 12px color=#409EFF">
      <el-dropdown style="font-size:20px">
        <i class="el-icon-user" style="cursor:pointer"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>{{username}}</el-dropdown-item>
          <app-UserCore></app-UserCore>
          <el-dropdown-item @click.native="tuichu()">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-header>
    <el-container>
      <app-tree></app-tree>
      <el-main class="el-main">
        <el-card>
          <router-view></router-view>
        </el-card>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      username: sessionStorage.username,
    };
  },
  methods: {
    tuichu() {
      sessionStorage.removeItem("userToken");
      this.$router.replace({
        path: "/login",
      });
    },
  },
};
</script>
<style >
.el-header {
  background-color: #409eff;
  color: #333;
  line-height: 60px;
}
</style>
